export const environment = {
  enableAnalytics: false,
  enableHubSpot: false,
  enableNgxsDebugging: true,
  googleAnalyticsId: null,
  hubSpotId: null,
  apiUrl: "https://test.landing-backend.externi.io",
  siteURL: "test.externi.io",
};
